import axios from "axios";


export const getDefaultInfo = async () => {
  const res = await axios.get("/api/default/info");
  return res.data;
};
export const getFeatureServicesInfo = async () => {
  const res = await axios.get("/api/default/services");
  return res.data;
};

export const getDoctorsInfo = async () => {
  const res = await axios.get("/api/doctors");
  return res.data;
};

export const createDoctor = async (data: object) => {
  const res = await axios.post("/api/doctors/add", data);
  return res.data;
};

export const updateDoctorById = async (id: number, data: object) => {
  const res = await axios.put(`/api/doctors/${id}`, data);
  return res.data;
};

export const deleteDoctorById = async (id: number) => {
  await axios.delete(`/api/doctors/${id}`);
};

export const getDepartmentsInfo = async () => {
  const res = await axios.get("/api/departments");
  return res.data;
};

export const createDepartment = async (data: object) => {
  const res = await axios.post("/api/departments/add", data);
  return res.data;
};

export const updateDepartmentById = async (id: number, data: object) => {
  const res = await axios.put(`/api/departments/${id}`, data);
  return res.data;
};

export const deleteDepartmentById = async (id: number) => {
  await axios.delete(`/api/departments/${id}`);
};

export const getTeamInfo = async () => {
  const res = await axios.get("/api/teams");
  return res.data;
};

export const createTeam = async (data: object) => {
  const res = await axios.post("/api/teams/add", data);
  return res.data;
};

export const updateTeamById = async (id: number, data: object) => {
  const res = await axios.put(`/api/teams/${id}`, data);
  return res.data;
};

export const deleteTeamById = async (id: number) => {
  await axios.delete(`/api/teams/${id}`);
};

export const getNewsInfo = async () => {
  const res = await axios.get("/api/news");
  return res.data;
};

export const createNews = async (data: object) => {
  const res = await axios.post("/api/news/add", data);
  return res.data;
};

export const updateNewsById = async (id: number, data: object) => {
  const res = await axios.put(`/api/news/${id}`, data);
  return res.data;
};

export const deleteNewsById = async (id: number) => {
  await axios.delete(`/api/news/${id}`);
};

export const longin = async (data: object) => {
  const res = await axios.post("/api/login", data);
  return res.data;
};